module.exports = __webpack_public_path__ + "assets/menpiao.96cd0e79.svg";